import React, { Component } from 'react';
import { Logger, FeatureDetector, immediate } from '@eyeson/js';

class AudioStream extends Component {
  constructor(props) {
    super(props);
    this.element = null;
    this.insidePip = props.insidePip || false;
    this.handleRef = this.handleRef.bind(this);
  }

  componentDidMount() {
    if (this.element) {
      this.element.muted = this.props.muted;
      this.updateSinkId(this.props.sinkId);
      if (this.props.stream) {
        if (this.props.persistent) {
          if (this.props.stream.getAudioTracks().length > 0) {
            const clone = new MediaStream(this.props.stream.getAudioTracks());
            this.element.srcObject = clone;
          }
        } else {
          this.element.srcObject = this.props.stream;
        }
      }
    }
    window.addEventListener('toggle_mute_speaker', this.updateMute);
  }

  shouldComponentUpdate(nextProps) {
    const { stream: s } = this.props;
    const { stream: ns } = nextProps;
    if (this.props.persistent) {
      const wasUnused = !this.element.srcObject;
      const hasStream = !!nextProps.stream;
      const sessionRestart = nextProps.sessionCount !== this.props.sessionCount;
      const newSinkId = nextProps.sinkId !== this.props.sinkId;
      const streamChange = !(s && ns && s.id === ns.id);
      return (
        (hasStream && (wasUnused || sessionRestart)) ||
        newSinkId ||
        streamChange
      );
    }
    return (
      !(s && ns && s.id === ns.id) ||
      nextProps.sinkId !== this.props.sinkId ||
      nextProps.muted !== this.props.muted ||
      nextProps.sessionCount !== this.props.sessionCount
    );
  }

  componentDidUpdate() {
    this.element.muted = this.props.muted;
    if (this.props.sinkId && this.props.sinkId !== this.element.sinkId) {
      this.updateSinkId(this.props.sinkId);
    }
    // especially used for safari to ensure streaming audio and prevent dom updates
    if (this.props.persistent && this.props.stream) {
      if (this.props.stream.getAudioTracks().length > 0) {
        const clone = new MediaStream(this.props.stream.getAudioTracks());
        this.element.srcObject = clone;
      }
    }
    this.updateMute();
  }

  componentWillUnmount() {
    window.removeEventListener('toggle_mute_speaker', this.updateMute);
  }

  handleRef(node) {
    if (node) {
      this.element = node;
      this.updateMute();
    }
  }

  updateSinkId = (sinkId) => {
    if (!FeatureDetector.canChangeAudioOutput() || this.insidePip) {
      return;
    }

    window.requestAnimationFrame(() => {
      const newSinkId = !sinkId || sinkId === 'default' ? '' : sinkId;
      if (this.element.sinkId !== newSinkId) {
        this.element.setSinkId(newSinkId).catch((error) => {
          Logger.warn('Audio::setSinkId', error);
        });
      }
    });
  };

  updateMute = () => {
    if (Object.hasOwn(this.props, 'speakerMuted')) {
      immediate(() => {
        if (this.element) {
          this.element.muted = this.props.speakerMuted || this.props.muted;
        }
      });
    }
  };

  render() {
    return (
      <audio ref={this.handleRef} autoPlay={true} muted={this.props.muted} />
    );
  }
}

export default AudioStream;
